<template>
  <div class="menuBody"  style="padding-left:25px;">
    <div class="menuTool" style="width:100%;">
      <el-card class="box-card">
        <el-row :gutter="10">
            <div style="border-bottom:1px solid rgba(234, 237, 241, 1);width:100%;height:40px;">
                系统配置
                  <div style="float:right;margin-left:50px">
                    <el-button type="primary" size="small" plain style="background: #246CE5;color:#fff;border-radius:9px;"
                              @click="addition()">添加
                    </el-button>
                  </div> 
            </div>       
    <el-table tooltip-effect="light"  v-loading="loading" :data="tableData" style="width: 100%;height:500px;margin-bottom: 20px;margin-top:20px" row-key="id" border  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
        <el-table-column show-overflow-tooltip prop="appName" label="系统名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="appCode" label="系统编码" ></el-table-column>
        <el-table-column show-overflow-tooltip prop="appIdentifier" label="系统唯一识别码" ></el-table-column>
        <el-table-column show-overflow-tooltip prop="effectiveDate" label="有效日期" ></el-table-column>
        <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
                <el-button @click="PayAllocation(scope.row)" type="primary" icon="el-icon-view" circle size="small"
                            title="查看支付配置"></el-button>
                <el-button @click="editMenu(scope.row)" type="primary" icon="el-icon-edit" circle size="small"
                            title="修改"></el-button>
                <el-button @click="delMenu(scope.row)" type="danger" icon="el-icon-delete" circle size="small"
                            title="删除"></el-button>
                <el-button @click="Reset(scope.row)" type="danger" icon="el-icon-refresh" circle size="small" 
                            title="重置"></el-button>       
                <el-button @click="download(scope.row)" type="primary" icon="el-icon-download" circle size="small" 
                            title="下载配置文件"></el-button>                                                   
            </template>
        </el-table-column>
    </el-table>
    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="float:right;margin-top:25px;">
    </el-pagination>
        </el-row>
      </el-card>
      <el-dialog
  title="选择下载"
  :visible.sync="dialog"
  width="30%"
  :before-close="handleClose">
    <el-radio v-model="radio" label="1">公钥</el-radio>
    <el-radio v-model="radio" label="2">私钥</el-radio>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialog = false">取 消</el-button>
    <el-button type="primary" @click="disposition()">确 定</el-button>
  </span>
</el-dialog>
    </div>
    <PayConfig  ref="PayConfig"/>
    <SystemConfigDialog @Visible="Visible" ref="SystemConfigDialog"/>
  </div>
</template>

<script>
import axios from 'axios'
import PayConfig from "./PayConfig.vue";
import SystemConfigDialog from "./SystemConfigDialog.vue"
export default {
  name: "SystemConfig",
  components: {PayConfig,SystemConfigDialog},
  data() {
    return {
        loading:false,
        total:0,//默认数据总数
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        tableData: [],
        dialog:false,
        radio:"1",
        objinfor:{},
    }
  },
  methods: {
    handleSizeChange(val) {
        this.pagesize  = val
        this.getAllMenu()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.getAllMenu()
    },
    addition(){
      this.$refs.SystemConfigDialog.dialogVisible = true
      this.$refs.SystemConfigDialog.result = {}
      this.$refs.SystemConfigDialog.title = "添加系统配置"
      this.$refs.SystemConfigDialog.switchover = true
    },
    getAllMenu() {
      let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
      }
      this.$http.post(this.$requestUrl.POST_SYS_CONFIG_LIST,PageSize).then((res) => {
        let result = res.data;
        if (200 === result.code) {
          this.total = result.data.total
          this.tableData = result.data.records;
          this.loading=false
        } else {
          this.$message.error(result.msg)
          this.loading = false
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
        this.loading = false
      })
    },
    editMenu(row) { // 修改
      this.$refs.SystemConfigDialog.dialogVisible = true
      this.$refs.SystemConfigDialog.result = row
      this.$refs.SystemConfigDialog.title = "修改系统配置"
      this.$refs.SystemConfigDialog.switchover = false
      this.$refs.SystemConfigDialog.effective = row.effectiveDate
    },
    delMenu(row){
        this.$confirm('是否确认要删除该配置?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.delete(this.$requestUrl.DELETE_SYS_CONFIG+row.id).then((res) => {
              let result = res.data;
            if (200 === result.code) {
              this.getAllMenu()
                 this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }else{
               this.$message({
                type: 'warning',
                message: '删除失败'
              });
            }
          }).catch(() => {
            this.$message.error(this.$errorMessage.SEVER_ERROR)
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    Reset(row){
      // GET_SYS_CONFIG_KEY
        this.$confirm('是否确认要重置该配置?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.get(this.$requestUrl.GET_SYS_CONFIG_KEY+row.id).then((res) => {
              let result = res.data;
            if (200 === result.code) {
              this.getAllMenu()
                 this.$message({
                type: 'success',
                message: '重置成功!'
              });
            }else{
               this.$message({
                type: 'warning',
                message: '重置失败'
              });
            }
          }).catch(() => {
            this.$message.error(this.$errorMessage.SEVER_ERROR)
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消重置'
          });          
        });
    },
    disposition(){
        var res = ""
        var arrstr = document.cookie.split("; ");
            for (var i = 0; i < arrstr.length; i++) {
                var temp = arrstr[i].split("=");
                if (temp[0] == "XF_L_T"){
                    res = temp[1]
                }else if(temp[0] == "JSESSIONID"){
                    res = temp[1]
                }
            }
      axios({
          methods: 'get',
          url: "http://localhost:9000/sys/web/application/config/download/"+this.radio,
          headers: {
              "Authorization":res,
              "Ac-ch-xf":"c4ca4238-a0b9-2382-0dcc-509a6f75849b",
              "xf_app_id":this.objinfor.appIdentifier,
              'Content-Type': 'application/octet-stream'
          },
          responseType:'blob'
      }).then((res) => {
        var blob = new Blob([res.data.data],{type:'charset=utf-8'}); 
        var element = document.createElement('a');            
        var href = window.URL.createObjectURL(blob); 					
        element.href = href;
        element.download = "xf-appConfig-private-dev.bat"; 		
        document.body.appendChild(element );
        element.click(); 												              
        document.body.removeChild(element ); 							    
        window.URL.revokeObjectURL(href); 								    
        this.dialog = false
        this.$message({
          type: 'success',
          message: '下载成功!'
        });
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
    },
    download(row){ // 下载配置文件
      this.dialog = true
      this.objinfor = row
    },
    PayAllocation(row){
        this.$refs.PayConfig.dialogVisible = true; 
        this.$refs.PayConfig.result = row
    },
      Visible(val){
        if(val == false){
          this.loading = true
         this.getAllMenu()
        }
      },
      handleClose(){

      },
  },
  mounted() {
    this.getAllMenu()
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;
    }
  }

}
</style>